export default "__VITE_ASSET__xE9yCTCl__"